import { getCustomCSSClasses } from '../pluginComponentApi';

export const getCustomCSSClassesTraits = async (projectId, version) => {
  const customCSSClassesResponse = await getCustomCSSClasses(projectId, version);
  const customCSSClassData = {};
  const customCSSClasses = [];
  const customCSSClassArray = [];
  customCSSClassesResponse.forEach((element) => {
    const classObj = {
      value: element.class,
      name: element.name,
    };
    customCSSClassArray.push(element.class);
    customCSSClasses.push(classObj);
  });
  customCSSClassData.customCSSClassArray = customCSSClassArray;
  customCSSClassData.customCSSClasses = customCSSClasses;
  return customCSSClassData;
};

export const preBuiltClassesTraitsOptions = () => {
  const options = [
    // {
    //   value: 'd-none',
    //   name: 'Hidden on all',
    // },
    // {
    //   value: 'd-none d-sm-block',
    //   name: 'Hidden only on xs',
    // },
    // {
    //   value: 'd-sm-none d-md-block',
    //   name: 'Hidden only on sm',
    // },
    // {
    //   value: 'd-md-none d-lg-block',
    //   name: 'Hidden only on md',
    // },
    // {
    //   value: 'd-lg-none d-xl-block',
    //   name: 'Hidden only on lg',
    // },
    // {
    //   value: 'd-xl-none',
    //   name: 'Hidden only on xl',
    // },
    // {
    //   value: 'd-none d-sm-block',
    //   name: 'Hidden only on xs',
    // },
    // {
    //   value: 'd-block',
    //   name: 'Visible on all',
    // },
    // {
    //   value: 'd-block d-sm-none',
    //   name: 'Visible only on xs',
    // },
    // {
    //   value: 'd-none d-sm-block d-md-none',
    //   name: 'Visible only on sm',
    // },
    // {
    //   value: 'd-none d-md-block d-lg-none',
    //   name: 'Visible only on md',
    // },
    // {
    //   value: 'd-none d-lg-block d-xl-none',
    //   name: 'Visible only on lg',
    // },
    // {
    //   value: 'd-none d-xl-block',
    //   name: 'Visible only on xl',
    // },
    {
      value: 'drapcode-1',
      name: 'DrapCode 1',
    },
    {
      value: 'drapcode-2',
      name: 'DrapCode 2',
    },
    {
      value: 'drapcode-3',
      name: 'DrapCode 3',
    },
  ];

  return [{ value: '', name: '- Select One -' }, ...options];
};

export const preBuiltClassesArray = [
  // 'd-none',
  // 'd-sm-block',
  // 'd-sm-none',
  // 'd-md-block',
  // 'd-md-none',
  // 'd-lg-block',
  // 'd-lg-none',
  // 'd-xl-block',
  // 'd-xl-none',
  // 'd-block',
  // 'd-sm-none',
  'drapcode-1',
  'drapcode-2',
  'drapcode-3',
];
